import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=3afd589a&scoped=true&"
import script from "./billing.vue?vue&type=script&lang=js&"
export * from "./billing.vue?vue&type=script&lang=js&"
import style0 from "./billing.vue?vue&type=style&index=0&id=3afd589a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd589a",
  null
  
)

export default component.exports